import apiRequest from 'shared/services/api';
// import { TAGS_TYPE } from 'shared/constant';
import { ACTION_TYPE } from './actionTypes';

const selectedProduct = payload => ({
  type: ACTION_TYPE.CATALOGUE.SELECTED_PRODUCT,
  payload,
});

const fetchCatalogue = () => async (dispatch, getState) => {
  try {
    const {
      authReducer: { token },
    } = getState();
    const res = await apiRequest.getCatalogueScreener(token);
    const mappedData = await res.rows.map(item => ({
      isin: item.ISIN,
      id: item.Id,
      fundName: item.FundName,
      investmentObjective: item.InvestmentObjective,
      productType: item.ProductType,
      geography: item.Geography,
      bannerSrc: item.MobileBanner,
      currency: item.Currency,
      annualizedReturn: item.AnnualizedReturn,
      benchmarkReturn: item.BenchmarkReturn,
      status: item.Status,
      category1: item.Category1,
      category2: item.Category2,
      investorType: item.InvestorType,
      displayOrder: item.DisplayOrder,
      subscription: item.Subscription,
      realEstateType: item.RealEstateType,
      investmentServiceType: item.InvestmentServiceType,
      investmentHorizon: item.InvestmentHorizon,
      targetNetIrr: item.TargetNetIrr,
      targetNetMultiple: item.TargetNetMultiple,
      nav: item.NAV,
      bankDetails: item.BankDetails,
    }));
    await dispatch({
      type: ACTION_TYPE.CATALOGUE.FETCH_SCREENER,
      payload: mappedData,
    });
  } catch (err) {
    console.error(err);
  }
};

const catalogueAction = {
  selectedProduct,
  fetchCatalogue,
};

export default catalogueAction;
